import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const ChatPreferencesSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="col-span-2">
        <SettingCardSkeleton
          titleWidth={140}
          controls={["input", "switch"]}
          showFooter
        />
      </div>
    </div>
  );
});

ChatPreferencesSkeleton.displayName = "ChatPreferencesSkeleton";

export default ChatPreferencesSkeleton;
